// Live office status in South African time (open daily 08:00 to 18:00).
// Updates any [data-gp-office] element and highlights today's row in [data-gp-hours].
(function () {
  var OPEN = 8 * 60, CLOSE = 18 * 60;
  var fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Johannesburg', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false });
  function now() {
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    return { day: parts.weekday, mins: (+parts.hour % 24) * 60 + (+parts.minute) };
  }
  function update() {
    var n = now();
    var open = n.mins >= OPEN && n.mins < CLOSE;
    var text = open ? 'Office open now, until 18:00' : (n.mins < OPEN ? 'Office opens today at 08:00' : 'Office opens tomorrow at 08:00');
    document.querySelectorAll('[data-gp-office]').forEach(function (el) {
      el.classList.toggle('gp-open', open);
      var t = el.querySelector('[data-gp-office-text]');
      if (t) t.textContent = el.hasAttribute('data-gp-short') ? (open ? 'Office open now' : 'Office closed, WhatsApp us') : text;
    });
    document.querySelectorAll('[data-gp-hours] tr[data-day]').forEach(function (tr) {
      tr.classList.toggle('is-today', tr.getAttribute('data-day') === n.day);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update); else update();
  setInterval(update, 60000);
})();
